/**
 * @generated SignedSource<<de9fe90553f5e4890bae7c7ad707e3ad>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081

import type { ConcreteRequest } from 'relay-runtime';
export type useFeatureDiscoveryMarkFeatureDiscoveredMutation$variables = {
  featureKey: string;
  pluginKey: string;
};
export type useFeatureDiscoveryMarkFeatureDiscoveredMutation$data = {
  readonly markFeatureDiscovered: {
    readonly featureKey: string;
    readonly pluginKey: string;
  } | null;
};
export type useFeatureDiscoveryMarkFeatureDiscoveredMutation = {
  response: useFeatureDiscoveryMarkFeatureDiscoveredMutation$data;
  variables: useFeatureDiscoveryMarkFeatureDiscoveredMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "featureKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pluginKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "featureKey",
        "variableName": "featureKey"
      },
      {
        "kind": "Variable",
        "name": "pluginKey",
        "variableName": "pluginKey"
      }
    ],
    "concreteType": "FeatureDiscoveryPayload",
    "kind": "LinkedField",
    "name": "markFeatureDiscovered",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "pluginKey"
      },
      {
        "kind": "ScalarField",
        "name": "featureKey"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
    "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
    "metadata": {},
    "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
    "operationKind": "mutation",
    "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
  }
};
})();

(node as any).hash = "55ae5a7186fb2a98e37da374a9b9784e";

export default node;
